import { Measurements } from './Measurements'
// import waist from '../../../../assets/icons/waist.png';
// import arms from '../../../../assets/icons/arms.png'
// import chest from '../../../../assets/icons/chest.png'
// import weight from '../../../../assets/icons/weight.png'
// import abdomen from '../../../../assets/icons/abdomen.png'
// import thighs from '../../../../assets/icons/thighs.png'
// import triglycerides from '../../../../assets/icons/triglycerides.png'
// import hips from '../../../../assets/icons/hips.png'
// import cholesterol from '../../../../assets/icons/cholesterol.png'
// import total_thyroxine_t4 from '../../../../assets/icons/total_thyroxine_t4.png'
import { Col, notification, Row, Spin } from 'antd'
import { useEffect, useState } from 'react'
import { listOfMeasurementTypesApi } from '../../../../config/Api'
import { API_ERR_MESSAGE } from '../../../../config/constant'

export const MeasurementsMaster = () => {
    const [measurementsData, setMeasurementsData] = useState([])
    const [loading, setLoading] = useState(false)

    // get the list of all measurements types
    //==============================
    const getListOfMeasurementTypes = () => {
        setLoading(true)

        listOfMeasurementTypesApi()
            .then((res) => {
                if (res.status === 200) {
                    // console.log(res.data.data);
                    const filteredData = res.data.data.filter(
                        (item) => item.name !== 'SGPT' && item.name !== 'GGT'
                    )
                    setMeasurementsData(filteredData)
                }
                setLoading(false)
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                })
            })
    }
    useEffect(() => {
        getListOfMeasurementTypes()
    }, [])

    // let MeasurementsData = [
    //     {
    //         name: "Weight",
    //         image: weight,
    //         Type: [{ name: 'kg', min: 10, max: 180 }]
    //     },
    //     {
    //         name: "Waist",
    //         image: waist,
    //         Type: [{ name: 'cm', min: 20, max: 200 }, { name: "in", min: 20, max: 200 }]
    //     },
    //     {
    //         name: "Arms",
    //         image: arms,
    //         Type: [{ name: 'cm', min: 10, max: 100 }, { name: "in", min: 3, max: 40 }]
    //     },
    //     {
    //         name: "Chest",
    //         image: chest,
    //         Type: [{ name: 'cm', min: 20, max: 200 }, { name: "in", min: 8, max: 78.7 }]
    //     },
    //     {
    //         name: "Hips",
    //         image: hips,
    //         Type: [{ name: 'cm', min: 20, max: 200 }, { name: "in", min: 8, max: 78.7 }]
    //     },
    //     {
    //         name: "Abdomen",
    //         image: abdomen,
    //         Type: [{ name: 'cm', min: 20, max: 200 }, { name: "in", min: 8, max: 78.7 }]
    //     },
    //     {
    //         name: "Total Cholesterol",
    //         image: cholesterol,
    //         Type: [{ name: 'mg/dL', min: 100, max: 500 }]
    //     },
    //     {
    //         name: "Triglycerides",
    //         image: triglycerides,
    //         Type: [{ name: 'mg/dL', min: 50, max: 600 }]
    //     },
    //     {
    //         name: "Thighs",
    //         image: thighs,
    //         Type: [{ name: 'cm', min: 15, max: 100 }, { name: "in", min: 6, max: 40 }]
    //     },
    //     {
    //         name: "Total Thyroxine-T4",
    //         image: total_thyroxine_t4,
    //         Type: [{ name: 'ug/dL', min: 1, max: 50 }]
    //     },
    //     {
    //         name: "LDL-Cholesterol",
    //         image: cholesterol,
    //         Type: [{ name: 'mg/dL', min: 50, max: 400 }]
    //     },
    //     {
    //         name: "SGOT",
    //         image: cholesterol,
    //         Type: [{ name: 'U/L', min: 1, max: 200 }]
    //     },
    //     {
    //         name: "Thyroid-Stimulating Hormone- TSH",
    //         image: total_thyroxine_t4,
    //         Type: [{ name: 'uIU/mL', min: 0.1, max: 20 }]
    //     },
    //     {
    //         name: "Total Triiodothyronine- T3",
    //         image: total_thyroxine_t4,
    //         Type: [{ name: 'ng/dL', min: 1, max: 300 }]
    //     },
    //     {
    //         name: "SGPT",
    //         image: cholesterol,
    //         Type: [{ name: 'U/L', min: 1, max: 200 }]
    //     },
    //     {
    //         name: "Alkaline Phosphatase",
    //         image: cholesterol,
    //         Type: [{ name: 'U/L', min: 1, max: 200 }]
    //     },
    //     {
    //         name: "GGT",
    //         image: cholesterol,
    //         Type: [{ name: 'U/L', min: 1, max: 400 }]
    //     },
    //     {
    //         name: "Insulin Fasting",
    //         image: cholesterol,
    //         Type: [{ name: 'uU/mL', min: 1, max: 200 }]
    //     },
    //     {
    //         name: "BP-Diastolic",
    //         image: abdomen,
    //         Type: [{ name: 'mmHg', min: 40, max: 200 }]
    //     },
    //     {
    //         name: "BP-Systolic",
    //         image: abdomen,
    //         Type: [{ name: 'mmHg', min: 60, max: 300 }]
    //     },
    //     {
    //         name: "Insulin Post Prandial",
    //         image: cholesterol,
    //         Type: [{ name: 'uU/mL', min: 1, max: 200 }]
    //     },
    //     {
    //         name: "Blood Sugar - Fasting (F)",
    //         image: cholesterol,
    //         Type: [{ name: 'mg/dL', min: 50, max: 500 },{ name: 'mmol/L', min: 2.8, max: 27.7 }]
    //     },
    //     {
    //         name: "Blood Sugar - Post Prandial (PP)",
    //         image: cholesterol,
    //         Type: [{ name: 'mg/dL', min: 50, max: 500 },{ name: 'mmol/L', min: 2.8, max: 27.7 }]
    //     },
    // ];
    return (
        <>
            <Row>
                <Col xl={{ offset: 10, span: 4 }}>
                    {/* <Card title="Shrey" style={{ width: '100%' }}>
                            <p><b>Age:</b>     26 Years</p>
                            <p><b>Gender:</b>  Male</p>
                            <p><b>Phone:</b> +919099885205</p>
                            <p><b>Program:</b> Weight Loss</p>
                            <p><b>Health Goal:</b> Weight Loss Program</p>
                    </Card> */}
                </Col>

                <Col span={24}>
                    <Spin spinning={loading} className="spinner-code">
                        {measurementsData.length > 0 &&
                            measurementsData.map((element, index) => {
                                return (
                                    <Measurements
                                        key={index}
                                        MeasurementData={element}
                                    />
                                )
                            })}
                    </Spin>
                </Col>
            </Row>
            {/* <Measurements MeasurementData={MeasurementsData[0]} /> */}
            {/* <Measurements image={waist} Title="Waist" Types={waistType} /> */}
            {/* <Measurements image={waist} Title="Waist" minValueOfSlider="10" maxValueOfSlider="100" /> */}
            {/* <Measurements image={abdomen} Title="Abdomen" minValueOfSlider="20" maxValueOfSlider="200" />
            <Measurements image={arms} Title="Arms"  minValueOfSlider="3" maxValueOfSlider="40" />
            <Measurements image={chest} Title="Chest"  minValueOfSlider="3" maxValueOfSlider="40" />
            <Measurements image={height} Title="Height"  minValueOfSlider="3" maxValueOfSlider="40" /> */}
        </>
    )
}
